'use client'

import { ImageLoaderProps } from 'next/image';

export default function ImageLoader({ src }: ImageLoaderProps) {
	return `${src}?v=${process.env.NEXT_PUBLIC_FILE_VERSION_ID}`;
}